import { createClient } from '@/lib/supabase/client';

const EDGE_FUNCTION_URL = `${process.env.NEXT_PUBLIC_SUPABASE_URL}/functions/v1/send-email`;

export async function callEmailFunction(payload: Record<string, string>) {
  try {
    const supabase = createClient();
    const { data: { session } } = await supabase.auth.getSession();
    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
    };
    if (session?.access_token) {
      headers['Authorization'] = `Bearer ${session.access_token}`;
    }
    const res = await fetch(EDGE_FUNCTION_URL, {
      method: 'POST',
      headers,
      body: JSON.stringify(payload),
    });
    return await res.json();
  } catch {
    return { success: false };
  }
}

export async function sendArtistWelcomeEmail(to: string, name: string) {
  return callEmailFunction({ type: 'artist_welcome', to, name });
}

export async function sendUserWelcomeEmail(to: string, name: string) {
  return callEmailFunction({ type: 'user_welcome', to, name });
}

export async function sendEmailVerification(to: string, name: string, verificationUrl: string) {
  return callEmailFunction({ type: 'email_verification', to, name, verificationUrl });
}

export async function sendVerificationCode(to: string, name: string, verificationCode: string) {
  return callEmailFunction({ type: 'verification_code', to, name, verificationCode });
}

export async function sendLoginNotification(to: string, name: string, loginTime: string, deviceInfo: string) {
  return callEmailFunction({ type: 'login_notification', to, name, loginTime, deviceInfo });
}

export async function sendCampaignSupportEmail(to: string, name: string, campaignTitle: string, amount: string, walletValue: string) {
  return callEmailFunction({ type: 'campaign_support', to, name, campaignTitle, amount, walletValue });
}

export async function sendMomentumValueUpdateEmail(to: string, name: string, campaignTitle: string, changePercent: string, newWalletValue: string) {
  return callEmailFunction({ type: 'momentum_value_update', to, name, campaignTitle, changePercent, newWalletValue });
}

export async function sendNotificationEmail(to: string, name: string, notifTitle: string, notifBody: string) {
  return callEmailFunction({ type: 'notification', to, name, notifTitle, notifBody });
}

export async function sendPasswordResetEmail(to: string, name: string, resetUrl: string) {
  return callEmailFunction({ type: 'password_reset', to, name, resetUrl });
}

export async function sendMCTBuyEmail(to: string, name: string, campaignTitle: string, quantity: number, totalPaid: number) {
  return callEmailFunction({
    type: 'notification',
    to,
    name,
    notifTitle: 'MCT Purchase Confirmed',
    notifBody: `You bought ${quantity.toLocaleString()} MCTs for "${campaignTitle}". Total paid: ₦${totalPaid.toLocaleString(undefined, { minimumFractionDigits: 2 })}.`,
  });
}

export async function sendMCTSellEmail(to: string, name: string, campaignTitle: string, quantity: number, netCredit: number) {
  return callEmailFunction({
    type: 'notification',
    to,
    name,
    notifTitle: 'MCT Sell Confirmed',
    notifBody: `You sold ${quantity.toLocaleString()} MCTs from "${campaignTitle}". Wallet credited: ₦${netCredit.toLocaleString(undefined, { minimumFractionDigits: 2 })} (after 10% service charge).`,
  });
}

export async function sendWalletFundedEmail(to: string, name: string, amount: number, newBalance: number) {
  return callEmailFunction({
    type: 'notification',
    to,
    name,
    notifTitle: 'Wallet Funded Successfully',
    notifBody: `₦${amount.toLocaleString(undefined, { minimumFractionDigits: 2 })} has been added to your EchoMint wallet. New balance: ₦${newBalance.toLocaleString(undefined, { minimumFractionDigits: 2 })}.`,
  });
}
